import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Field } from "react-final-form";
import { ChipsInput } from "@vk-hr-tek/ui/input";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ChipsInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ChipsInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const ChipsInput_ChipsInput = (t0)=>{
    const $ = c(35);
    let items;
    let label;
    let labelIcon;
    let name;
    let onChange;
    let required;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let tooltip;
    let type;
    if ($[0] !== t0) {
        ({ type, label, labelIcon, name, onChange, items, required, disabled: t1, size: t2, showError: t3, loading: t4, tooltip, testId } = t0), rest = _object_without_properties(t0, [
            "type",
            "label",
            "labelIcon",
            "name",
            "onChange",
            "items",
            "required",
            "disabled",
            "size",
            "showError",
            "loading",
            "tooltip",
            "testId"
        ]);
        $[0] = t0;
        $[1] = items;
        $[2] = label;
        $[3] = labelIcon;
        $[4] = name;
        $[5] = onChange;
        $[6] = required;
        $[7] = rest;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = testId;
        $[13] = tooltip;
        $[14] = type;
    } else {
        items = $[1];
        label = $[2];
        labelIcon = $[3];
        name = $[4];
        onChange = $[5];
        required = $[6];
        rest = $[7];
        t1 = $[8];
        t2 = $[9];
        t3 = $[10];
        t4 = $[11];
        testId = $[12];
        tooltip = $[13];
        type = $[14];
    }
    const disabled = void 0 === t1 ? false : t1;
    const size = void 0 === t2 ? "large" : t2;
    const showError = void 0 === t3 ? true : t3;
    const loading = void 0 === t4 ? false : t4;
    let t5;
    if ($[15] !== onChange || $[16] !== type) {
        t5 = (input)=>(nextValue)=>{
                const convertedVal = "number" === type && "string" == typeof nextValue ? parseInt(nextValue, 10) : nextValue;
                input.onChange(convertedVal);
                if (onChange) onChange(convertedVal);
            };
        $[15] = onChange;
        $[16] = type;
        $[17] = t5;
    } else t5 = $[17];
    const handleChange = t5;
    let t6;
    if ($[18] !== disabled || $[19] !== handleChange || $[20] !== items || $[21] !== label || $[22] !== labelIcon || $[23] !== loading || $[24] !== required || $[25] !== showError || $[26] !== size || $[27] !== testId || $[28] !== tooltip) {
        t6 = (t7)=>{
            const { input: input_0, meta } = t7;
            return /*#__PURE__*/ jsx(ChipsInput, _object_spread_props(_object_spread({}, input_0), {
                testId: testId,
                items: items,
                tooltip: tooltip,
                value: input_0.value,
                onChange: handleChange(input_0),
                size: size,
                required: required,
                error: meta.touched && !!meta.error,
                helperText: showError && meta.touched && meta.error,
                label: label,
                labelIcon: labelIcon,
                loading: loading,
                disabled: disabled,
                activeSingleOption: false
            }));
        };
        $[18] = disabled;
        $[19] = handleChange;
        $[20] = items;
        $[21] = label;
        $[22] = labelIcon;
        $[23] = loading;
        $[24] = required;
        $[25] = showError;
        $[26] = size;
        $[27] = testId;
        $[28] = tooltip;
        $[29] = t6;
    } else t6 = $[29];
    let t7;
    if ($[30] !== disabled || $[31] !== name || $[32] !== rest || $[33] !== t6) {
        t7 = /*#__PURE__*/ jsx(Field, _object_spread_props(_object_spread({
            name: name
        }, rest), {
            disabled: disabled,
            children: t6
        }));
        $[30] = disabled;
        $[31] = name;
        $[32] = rest;
        $[33] = t6;
        $[34] = t7;
    } else t7 = $[34];
    return t7;
};
export { ChipsInput_ChipsInput as ChipsInput };
